module.exports = __webpack_public_path__ + "static/img/zf_img_function_picture.d75f3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_function_picture.png
// module id = zOJ7
// module chunks = 1